export default [
  "Cigarette Butt",
  "Express courier",
  "Ice",
  "Sand",
  "Herbal medicine",
  "Toy blocks",
  "Broom",
  "Spring",
  "Internet cable",
  "Lunch box",
  "Cake",
  "Coins",
  "Invitation card",
  "Peanut",
  "Test tube",
  "Glue",
  "Dog fur",
  "Diamond",
  "Juice",
  "Flashlight",
  "Maze",
  "Red wine",
  "Table lamp",
  "Button",
  "Sack",
  "Rat",
  "Fiber Optics",
  "Lightbulb",
  "Needle and Thread",
  "Rose",
  "Hourglass",
  "Timber",
  "Ants",
  "Fan",
  "Panties",
  "Puzzle",
  "Luggage",
  "IV Bag",
  "Survaillance camera",
  "Oil Stain",
  "Umbrella",
  "Carton",
  "Skull",
  "Suit",
  "Comics",
  "Spinning Top",
  "Tweezers",
  "Key",
  "Hair",
  "Violin",
  "Cup",
  "Office supplies",
  "Stuffed Toy",
  "Badge",
  "Oil Painting",
  "Vegetables",
  "Helmet",
  "Lipstick",
  "Betting Chips",
  "Seasoning",
  "Playing cards",
  "Gift",
  "Snacks",
  "Pocket watch",
  "Hairpin",
  "Mirror",
  "Signature",
  "Leaf",
  "Bone",
  "Mosquito Coil",
  "Flute",
  "Ring",
  "Numbers",
  "Blood",
  "Fax",
  "Briefs",
  "Perfume",
  "Antique",
  "Electric Circuit",
  "Mobile Phone",
  "Sock",
  "Mask",
  "Dice",
  "Bullet",
  "Computer",
  "Leather Bag",
  "Plastic",
  "Tea leaves",
  "Sawdust",
  "High heel",
  "Photograph",
  "Watch",
  "Cigar ",
  "Raincoat",
  "Leather shoe",
  "Certificate",
  "Video camera",
  "Earrings",
  "Fingernails",
  "Match",
  "Tissue",
  "Uniform",
  "Dust",
  "Safety Pin",
  "Newspaper",
  "Lens",
  "Computer mouse",
  "Lock",
  "Steamed buns",
  "Paint",
  "Gloves",
  "Soft drink",
  "Plant",
  "Soap",
  "Flyer",
  "Menu",
  "Flip-flop",
  "Telephone",
  "Nail",
  "Curtains",
  "ID Card",
  "Receipt",
  "Speaker",
  "Cockroach",
  "Wallet",
  "Exam Paper",
  "Lottery Ticket",
  "Candy",
  "Magazine",
  "Calendar",
  "Bandage",
  "Hanger",
  "Coffee",
  "Bell",
  "USB Flash Drive",
  "Cigarette Ash",
  "Mark",
  "Powder",
  "Dentures",
  "Confidential letter",
  "Surgical Mask",
  "Cat",
  "Food Ingredients",
  "Puppet",
  "Rubber stamp",
  "Book",
  "Postal stamp",
  "Mahjong Tiles",
  "Dictionary",
  "Spider",
  "Jewelry",
  "Hat",
  "Note",
  "Syringe",
  "Gear",
  "Model",
  "Banknote",
  "Bread",
  "Insect",
  "Riddle",
  "Apple",
  "Graffiti",
  "Chalk",
  "Air Conditioning",
  "Jacket",
  "Headset",
  "Cosmetic Mask",
  "Sunglasses",
  "Toy",
  "Cotton",
  "Notebook",
  "Computer disk",
  "Ink",
  "Toothpick",
  "Necklace",
  "Envelope",
  "Diary",
  "Wig",
  "Documents",
  "Map",
  "Dirt",
  "Mosquito",
  "Toolbox",
  "Business card",
  "Tie",
  "Cleaning cloth",
  "Stockings",
  "Push pin",
  "Sponge",
  "IOU Note",
  "Handcuffs",
  "Tattoo",
  "Bracelet",
  "Take-out",
  "Prescription",
  "Iron",
  "Eggs",
  "Love letter",
  "Cassette tape"
];
